export const VITALS_ERROR_TEXTS = {
  invalidDateFormat: 'Please enter a valid date.',
  min: 'must be greater than',
  max: 'must not exceed',
};

export const VITALS_AUTO_CALCULATION_HINT = 'Calculated using PatientNow formulas';

export const VITALS_DATE_FORMATS = {
  parse: {
    dateInput: ['M/D/YYYY', 'MM/DD/YYYY'],
  },
  display: {
    dateInput: 'M/D/YYYY',
    monthYearLabel: 'MMMM YYYY',
    dateA11yLabel: 'MM/DD/YYYY',
    monthYearA11yLabel: 'MMMM YYYY',
  },
};
